import { BusMessage, MessageFactory, UID_BYTES_PER_ELEMENT, BOOLEAN_BYTES_PER_ELEMENT, ENUM_BYTES_PER_ELEMENT, calcStringByteLength } from "flavr-common";
/**
 * Shows or hides a model indicator.
 */
export class ShowModelIndicatorMessage extends BusMessage {
    get byteLength() {
        return ShowModelIndicatorMessage.BYTE_LENGTH + calcStringByteLength(this.url);
    }
    constructor(uid, url, show, button) {
        super();
        this.uid = uid;
        this.url = url;
        this.show = show;
        this.button = button;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.url = stream.utf16String(this.url);
        this.show = stream.boolean(this.show);
        this.button = stream.enum(this.button);
    }
    static is(msg) {
        return msg.type === ShowModelIndicatorMessage.typestatic;
    }
}
ShowModelIndicatorMessage.typestatic = "ShowModelIndicatorMessage";
ShowModelIndicatorMessage.subjectstatic = "general";
ShowModelIndicatorMessage.BYTE_LENGTH = (UID_BYTES_PER_ELEMENT + // uid
    BOOLEAN_BYTES_PER_ELEMENT + // show
    ENUM_BYTES_PER_ELEMENT // button
);
MessageFactory.register(ShowModelIndicatorMessage);
